import { TestNetConfig, NetworkInfo as _tn_info } from "./testnetConfig";
import { MainNetConfig, NetworkInfo as _mn_info } from "./mainnet";

export const config =
  process.env.NEXT_PUBLIC_NETWORK == "mainnet" ? MainNetConfig : TestNetConfig;

export const currentNetworkInfo =
  process.env.NEXT_PUBLIC_NETWORK == "mainnet" ? _mn_info : _tn_info;
